<template>
  <div id="live_list">
    <div class="bread">
      <el-breadcrumb>
        <el-breadcrumb-item :to="{path: '/watch_teacher'}">缴费客户观看老师明细</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="bottom cont">
      <div class="titlebox">
        <div class="title">缴费客户观看老师明细</div>
        <div class="notice">
          <span class="right_grid">
            <span class="refresh" @click="refresh">刷新</span>

          </span>
        </div>
      </div>
      <div class="string"></div>
      <div class="navs">
        <el-form class="course_search_form" ref="course_search_form" size="large">
          <el-form-item label="版本">
            <el-select v-model="search.groupid" style="width: 230px" @change="getData">
              <el-option v-for="(item, index) in group" :key="index" :label="item.value" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资源进线时间" style="margin-left: 16px;">
            <el-date-picker v-model="search.date" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" @change="getData" format="YYYY-MM-DD" value-format="YYYY-MM-DD">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <!-- 表 -->
      <div class="watch_teacher" v-for="(item,i) in tableData">
        <p class="name">{{item.name}}</p>
        <div class="content">
          <div class="card">
            <div class="number">{{item.num1}}</div>
            <div class="status">{{item.num1_name}}</div>
          </div>
          <div class="card">
            <div class="number">{{item.num2}}</div>
            <div class="status">{{item.num2_name}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import './assets/less/list.less';
  import list_model from "./model/model";
  import common_model from '@/common/model';
  import moment from "moment/moment";
  import {
    reactive
  } from "vue";
  var that = null
  export default {
    components: {},
    data() {
      that = this
      return {
        loading: false,
        tableHeight: 350,
        tableData: [],
        page: {
          loading: false,
          pageSize: 50,
          total: 0,
          size: 10,
          current: 1,
          pageSizes: [10, 20, 50, 100],
        },
        group: [{
            id: "531",
            value: "追龙版"
          },
          {
            id: "530",
            value: "游资版"
          }
        ],
        search: {
          groupid: "530",
          date: []
        }
      }
    },
    mounted() {
      that.$nextTick(() => {
        that.init()
      });
    },
    methods: {
      init() {
        //用户权限处理
        common_model.getUserInfo().then((res) => {
          that.userInfo = res;
          that.setDefaultDateRange()
          that.getData()
        });
      },
      setDefaultDateRange() {
        const today = new Date();
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1); // 当月 1 号
        const endOfToday = new Date(today); // 今天

        // 格式化日期为 YYYY-MM-DD
        const formatDate = (date) => {
          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1
          const d = String(date.getDate()).padStart(2, '0');
          return `${y}-${m}-${d}`;
        };

        that.search.date = [formatDate(startOfMonth), formatDate(endOfToday)];
      },
      /**
       * 获取列表数据
       */
      getData() {
        that.loading = true;

        let params = reactive({
          begin_time: that.search.date[0],
          end_time: that.search.date[1],
          groupid: that.search.groupid
        })
        list_model.get_watch_teacher_info(params).then(res => {
          that.loading = false;
          if (res.code === 0) {
            let data = res.list
            let new_list = [{
              "name": "全部观看",
              "num1_name": "观看课程总数",
              "num1": data.all,
              "num2_name":"同时观看高进城及庄海峰",
              "num2": data.look_gao_and_zhuang
            },
            {
              "name": "高进城",
              "num1_name":"观看",
              "num1": data.look_gao,
              "num2_name":"仅观看",
              "num2": data.look_own_gao
            },
            {
              "name": "庄海峰",
              "num1_name":"观看",
              "num1": data.look_zhuang,
              "num2_name":"仅观看",
              "num2": data.look_own_zhuang
            },]
            that.tableData = new_list
          }
        });
      },

      /* 数据刷新 */
      refresh() {
        that.getData()
      },
    },
    filters: {

    }
  }
</script>

<style>
  * {
    padding: 0;
  }
</style>
